import { ITableColumn, TableColumn, ColumnDataTypes } from 'new-table-editor';
import { ContactPhone } from 'starbase-launcher';

// eslint-disable-next-line @typescript-eslint/naming-convention
export class ContactPhone_ext extends ContactPhone {
  public static ContactPhoneColumns(): ITableColumn[] {
    const phCol = new TableColumn('phoneNumber', 'Phone #', ColumnDataTypes.phone, true, true, true);
    phCol.maxLength = 14;
    phCol.minLength = 10,
    phCol.visible = true;
    phCol.allowSort = true;
    phCol.placeholder = 'Phone number';

    const peCol = new TableColumn('phoneExtension', 'Ext.', ColumnDataTypes.string, false, true);  // use ngx-mask ?
    peCol.maxLength = 4;
    peCol.allowSort = false;
    peCol.tooltip = 'Phone extension';
    const preferredCol = new TableColumn('preferred', '', ColumnDataTypes.yesno, false, true, false);
    preferredCol.iconClass = 'fa-check';
    preferredCol.allowSort = false;
    preferredCol.tooltip = 'Preferred';
    preferredCol.textAlignment = 'center';
    preferredCol.colWidth = '20px';
    const smsCol = new TableColumn('receiveSMS', 'SMS', ColumnDataTypes.yesno, false, true, false);
    smsCol.allowSort = false;
    smsCol.tooltip = 'Check if this number receives text messages';
    smsCol.textAlignment = 'center';
    const suffixCol = new TableColumn('smsSuffix', 'SMS Suffix', ColumnDataTypes.string);
    suffixCol.visible = false;
    return [
      /* { columnName: 'commType',
      displayName: 'Comm Type', dataType: ColumnDataTypes.string, visible: false, required: true, editable: false, colloquial: false }, */
      phCol,
      peCol,
      new TableColumn('description', 'Description', ColumnDataTypes.string, false, true),
      preferredCol,
      smsCol,
      suffixCol,
      {
        columnName: 'contactUID', displayName: 'Contact UID',
        dataType: ColumnDataTypes.number, visible: false, required: false, editable: false, colloquial: false, editableNew: true
      }, // actually required but added in the data service when POSTing
      ...TableColumn.generateColumnsForStarbaseEntity()
    ];
  }
}
